import { useState } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { mockUsers, MockUser } from "@/data/mockData";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Recherche d'un utilisateur actif dans le mock avec ce username + password
    const user: MockUser | undefined = mockUsers.find(
      (u) => u.username === username && u.password === password && u.isActive
    );

    if (user) {
      toast.success("Connexion réussie !");
      sessionStorage.setItem("isAdminLoggedIn", user.role === "admin" ? "true" : "false");
      sessionStorage.setItem("currentUser", JSON.stringify(user));
      setLoading(false);
      // Si l'utilisateur est admin, on l'emmène vers /admin sinon page accueil
      if (user.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/");
      }
    } else {
      setError("Nom d'utilisateur ou mot de passe incorrect.");
      toast.error("Identifiants invalides.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/40 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary">Mucodec Digital</h1>
          <p className="text-muted-foreground">Gestionnaire administration</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Connexion</CardTitle>
            <CardDescription>
              Veuillez entrer votre nom d'utilisateur et votre mot de passe.
            </CardDescription>
          </CardHeader>
          <form onSubmit={handleSubmit} autoComplete="on">
            <CardContent className="space-y-4">
              {error && (
                <div className="p-3 bg-destructive/10 text-destructive text-sm rounded-md">
                  {error}
                </div>
              )}
              <div className="space-y-2">
                <Label htmlFor="username">Nom d'utilisateur</Label>
                <Input
                  id="username"
                  type="text"
                  placeholder="Nom d'utilisateur"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                  autoComplete="username"
                  disabled={loading}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Mot de passe</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  disabled={loading}
                />
              </div>
            </CardContent>
            <CardFooter className="flex flex-col space-y-4">
              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? "Connexion..." : "Connexion"}
              </Button>
              <div className="text-center text-sm">
                <Link to="/" className="text-primary hover:underline">
                  Retour à l'accueil
                </Link>
              </div>
            </CardFooter>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
